module.exports = __webpack_public_path__ + "static/media/lovefromyours-logo.2d64c776.svg";